// Reconcile server refreshes without turning inherited values into interview answers.
const equal=(a,b)=>JSON.stringify(a)===JSON.stringify(b)
export function rebaseDiscoveryForm(state,next){
  const form={...state.form},baselineChanges={...state.baselineChanges}
  for(const key of Object.keys(next)){
    const dirty=!equal(state.form[key],state.initial[key])
    if(!dirty)form[key]=next[key]
    if((key==='quantity'||key==='inHandsDate')&&dirty&&!equal(state.initial[key],next[key])){
      baselineChanges[key]={previous:state.initial[key],current:next[key]}
    }
    if(equal(form[key],next[key]))delete baselineChanges[key]
  }
  return {initial:next,form,baselineChanges}
}
